import { render, staticRenderFns } from "./review-list.vue?vue&type=template&id=0ec5d28d&"
import script from "./review-list.vue?vue&type=script&lang=js&"
export * from "./review-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports